import api from "../services/axios";

class ServiceSupplier {
  async saveSupllier(dataSupplier) {
      if(dataSupplier === undefined){
       return
      }
      const { data } = await api.post("/Providers", dataSupplier);
      return data.id;
  }

  async fillComobobox(selectedId){
    const { data } = await api.get("/providers/fill/combobox", {
      params: selectedId ? { selectedId } : {},
    });
    return data
  }

  async findById(id) {
    const { data } = await api.get(`/providers/${id}`);
    return data
  }
}

export default new ServiceSupplier()
